import Modal from '../Modal';
import { ampli } from "../../ampli";
import { Link } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { MessagesContext } from '../../pages/NarrativePage/contexts/MessagesContext';
import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import Tooltip from '../Tooltip/Tooltip';
import DOMPurify from 'dompurify';
import {platformIconsMapping, platformNamesMapping} from '../../utils/platforms';
import {contentTypesIconsMapping, contentTypesMapping} from '../../utils/contentTypes';
import { decodeSourceName } from '../../utils/decodeURI';

import { ReactComponent as ApproveIcon } from '../../pages/NarrativePage/assets/approve.svg';
import { ReactComponent as DeleteIcon } from '../../assets/delete.svg';
import { ReactComponent as LinkIcon } from '../../assets/link.svg';
import { ReactComponent as CalendarIcon } from '../../assets/calendar.svg';
import { ReactComponent as FollowersIcon } from '../../assets/followers.svg';
import { ReactComponent as EnvelopeOpenIcon } from '../../assets/envelopeOpen.svg';
import { ReactComponent as RecoverIcon } from '../../assets/recover.svg';
import { ReactComponent as ActorIcon } from '../../pages/SearchPage/assets/link.svg';
import { ReactComponent as SourceIcon } from '../../pages/SearchPage/assets/person.svg';
import { ImagesContainer } from '../Image/ImagesContainer';
import { formatNumberSignificant } from '../../utils/fomatNumbers';
import { Tooltip as ReactTooltip} from 'react-tooltip';
import { OriginalTextBlock } from './OriginalTextBlock';
import { MessageMetricsWrapper } from './MessageMetricsWrapper';

import styles from './ExtendedMessageView.module.scss';
import { useCurrentUser } from '../../contexts/CurrentUser';

const statusMapping = {
  NEW: {class: styles.new, name: 'New'},
  READ: {class: styles.approved, name: 'Approved'},
  DELETED: {class: styles.deleted, name: 'Deleted'}
}

export const MessageModal = ({message, isOpen, onChange, selected, narrativeMessage, isShare, showSentimentIcon = true }) => {
  const {
    deduplication,
    patchMessages,
    deleteMessages,
    getMessages,
    dispatch,
  } = useContext(MessagesContext);
  const { t } = useTranslation();
  const [currentUser] = useCurrentUser();
  const [highlightsMenu, setHighlightsMenu] = useState(false);
  const [highlights, setHighlights] = useState(selected ? selected : ['KEYWORDS']);

  
  let followers_cnt = message?.source?.audience;

  const translatedText = message?.translated;
  const messageText = message.highlighted_text || message.text || message.message;
  let newText;

  if(message?.isTranslation && translatedText?.length > 0) {
    newText = translatedText.replace(/\n+(\s*\n+)?/g, '\n').split('\n');
  } else {
    newText = messageText.replace(/\n+(\s*\n+)?/g, '\n').split('\n');
    
  }
  const sanitizedText = newText.map(item => DOMPurify.sanitize(item, { ALLOWED_TAGS: ['mark', 'span'],  ALLOWED_ATTR: ['class']}));
  

  useEffect(() => {
    const keywords = document.querySelectorAll('#message-modal-text .keywords-highlight');
    const ner = document.querySelectorAll('#message-modal-text .ner-highlight');
    const person = document.querySelectorAll('#message-modal-text .ner-highlight[data-ner-type="Person"]');
    const location = document.querySelectorAll('#message-modal-text .ner-highlight[data-ner-type="Location"]');
    const organization = document.querySelectorAll('#message-modal-text .ner-highlight[data-ner-type="Organization"]');

    if (highlights.includes('KEYWORDS')) {
      keywords.forEach(item => {
        item.classList.add('active')
      })
    } else {
      keywords.forEach(item => {
        item.classList.remove('active')
      })
    }

    if (highlights.includes('PERSON')) {
      person.forEach(item => {
        item.classList.add('active')
      })
    } else {
      person.forEach(item => {
        item.classList.remove('active')
      })
    }

    if (highlights.includes('LOCATION')) {
      location.forEach(item => {
        item.classList.add('active')
      })
    } else {
      location.forEach(item => {
        item.classList.remove('active')
      })
    }

    if (highlights.includes('ORGANIZATION')) {
      organization.forEach(item => {
        item.classList.add('active')
      })
    } else {
      organization.forEach(item => {
        item.classList.remove('active')
      })
    }

   }, [highlights])

   useEffect(() => {
      const container = document.querySelector('#message-modal-text');
      const content = document.querySelector(".dropdown-menu-container");
    if(highlightsMenu) {
      container.style.height=container.offsetHeight + content.offsetHeight + "px";
    } else {
      container.style.height=''
    }
  
   }, [highlightsMenu])

   const tooltipStyles = {
    zIndex: 1000,
    textAlign: 'center',
    borderRadius: '6px',
    whiteSpace: 'pre-line',
  };


  
  return (
    <Modal
      isVisible={isOpen}
      title={
        <>
          <div className={styles.messageInfo}>
            {narrativeMessage ? (
              <div
                className={`${styles.status} ${
                  statusMapping[message.status].class
                }`}
              >
                {t(statusMapping[message.status].name)}
              </div>
            ) : (
              ''
            )}
            {message.content_type !== null ? (
              <div className={styles.contentType}>
                <Tooltip
                  content={t(contentTypesMapping[message.content_type])}
                  position="bottom"
                >
                  {contentTypesIconsMapping[message.content_type]}
                </Tooltip>
              </div>
            ) : (
              ''
            )}
            <div className={styles.date}>
              <span className={styles.anchor}>
                <Tooltip content={t('Publication date')} position="bottom">
                  <CalendarIcon />
                </Tooltip>
              </span>
              {message.date_publicated
                ? format(
                    parseISO(message.date_publicated + 'Z'),
                    'dd LLL yyyy HH:mm',
                  )
                : format(
                    parseISO(message.published_at + 'Z'),
                    'dd LLL yyyy HH:mm',
                  )}
            </div>
            <div className={styles.platform}>
              <span className={styles.anchor}>
                <Tooltip
                  content={platformNamesMapping[message.source?.source_type]}
                  position="bottom"
                >
                  {platformIconsMapping[message.source?.source_type]}
                </Tooltip>
              </span>
              {followers_cnt ? (
                <span className={styles.anchor}>
                  <Tooltip content={t('Followers')} position="bottom">
                    <FollowersIcon />
                  </Tooltip>
                  <span>{formatNumberSignificant(followers_cnt)}</span>
                </span>
              ) : (
                ''
              )}
            </div>
            <div className={styles.sourceActorWrapper}>
              <span className={styles.anchor}>
                <div>
                  <ActorIcon />
                  <span
                    className={styles.cutText}
                    data-tooltip-id='source-info'
                    data-tooltip-html={message?.source ? `${decodeSourceName(message.source.name)}<br/>${message.source.url}` : t('N/A')}
                  >
                    {isShare ? (
                      decodeSourceName(message.source.name)
                    ) : message.source ? (
                      <Link
                        to={`/sources/${message.source?.id}`}
                        onClick={() => {
                          ampli.track({
                            event_type: 'Open source profile',
                            event_properties: {
                              user_id: currentUser?.id,
                              workspace_id:
                                currentUser?.workspace_id,
                              source_id: message.source.id,
                            },
                          });
                        }}
                      >
                        {decodeSourceName(message.source.name)}
                      </Link>
                    ) : (
                      t('N/A')
                    )}
                  </span>
                </div>
                {message.actor &&
                message.actor.id !== message.source?.id ? (
                  <div>
                    <SourceIcon />
                    <span
                      className={styles.cutText}
                      data-tooltip-id='actor-info'
                      data-tooltip-html={`${decodeSourceName(message.actor?.name)} <br/>${message.actor?.url}`}
                    >
                      {isShare ? (
                        decodeSourceName(message.actor?.name)
                      ) : (
                        <Link to={`/sources/${message.actor?.id}`}>
                          {decodeSourceName(message.actor?.name)}
                        </Link>
                      )}
                    </span>
                  </div>
                ) : (
                  ''
                )}
              </span>
              <a
                href={message.url ? message.url : message.message_url}
                target="_blank"
                rel="noopener noreferrer"
                data-tooltip-id='publication-link'
                data-tooltip-content={t('Go to publication')}
              >
                <LinkIcon />
              </a>
            </div>
          </div>
        </>
      }
      content={
        <>
          <div className={styles['metrics-container']}>
            <MessageMetricsWrapper
              message={message}
              isShare={isShare}
            />
          </div>

          <div className={styles.messageText} id="message-modal-text">
            {' '}
            {message.parent_message ? (
              <OriginalTextBlock
                message={message}
                isShare={isShare}
                currentUser={currentUser}
              />
            ) : (
              ''
            )}

            {message?.images && message?.images?.length > 0 ? <ImagesContainer images={message?.images} showCount={3} /> : ''}
            {sanitizedText.map((item, index) => (
              <p
                key={`paragraph_${index}`}
                dangerouslySetInnerHTML={{ __html: item }}
              ></p>
            ))}
          </div>
        </>
      }
      footer={
        <>
          {(narrativeMessage &&
            narrativeMessage.narrative.review_status === 'PENDING' &&
            !isShare &&
            narrativeMessage.narrative.is_threat) ||
          (narrativeMessage &&
            !narrativeMessage.narrative.is_threat &&
            !isShare) ? (
            <div className={styles.controls}>
              <button
                className={`${styles.approve} btn-primary`}
                disabled={message.status === 'DELETED' ? true : false}
                onClick={() => {
                  let status = message.status === 'NEW' ? 'READ' : 'NEW';
                  let messageIds = [message.id];

                  patchMessages(
                    narrativeMessage.narrative,
                    status,
                    messageIds,
                    deduplication,
                  ).then(() => {
                    dispatch({ type: 'PATCH_MESSAGES' });
                    getMessages(
                      narrativeMessage.narrative,
                      narrativeMessage.searchQuery,
                      narrativeMessage.sorting,
                      narrativeMessage.statuses,
                      deduplication,
                      narrativeMessage.page,
                    );
                  });
                  onChange(false);
                }}
              >
                {message.status === 'NEW' ? (
                  <ApproveIcon />
                ) : (
                  <EnvelopeOpenIcon />
                )}
              </button>
              <button
                className={`${styles.delete} btn-danger`}
                onClick={() => {
                  let messageIds = [message.id];
                  if (message.status === 'DELETED') {
                    patchMessages(
                      narrativeMessage.narrative,
                      'NEW',
                      messageIds,
                      deduplication,
                    ).then(() => {
                      dispatch({ type: 'PATCH_MESSAGES' });
                      getMessages(
                        narrativeMessage.narrative,
                        narrativeMessage.searchQuery,
                        narrativeMessage.sorting,
                        narrativeMessage.statuses,
                        deduplication,
                        narrativeMessage.page,
                      );
                    });
                    onChange(false);
                  } else {
                    deleteMessages(
                      narrativeMessage.narrative,
                      messageIds,
                      deduplication,
                    ).then(() => {
                      dispatch({ type: 'DELETE_MESSAGES' });
                      getMessages(
                        narrativeMessage.narrative,
                        narrativeMessage.searchQuery,
                        narrativeMessage.sorting,
                        narrativeMessage.statuses,
                        deduplication,
                        narrativeMessage.page,
                      );
                    });
                    onChange(false);
                  }
                }}
              >
                {message.status === 'DELETED' ? (
                  <RecoverIcon />
                ) : (
                  <DeleteIcon />
                )}
              </button>
            </div>
          ) : (
            ''
          )}
          <ReactTooltip id='source-info' place='bottom' style={tooltipStyles} />
          <ReactTooltip id='actor-info' place='bottom' style={tooltipStyles} />
          <ReactTooltip id='publication-link' place='bottom' style={tooltipStyles} />
          <ReactTooltip
              id="message-views"
              place="bottom"
              style={tooltipStyles}
            />
            <ReactTooltip
              id="message-comments"
              place="bottom"
              style={tooltipStyles}
            />
            <ReactTooltip
              id="message-reposts"
              place="bottom"
              style={tooltipStyles}
            />
            <ReactTooltip
              id="message-reactions"
              place="bottom"
              style={tooltipStyles}
            />
            <ReactTooltip
              id="message-engagement"
              place="bottom"
              style={tooltipStyles}
            />
            <ReactTooltip
              id="message-similarity"
              place="bottom"
              style={tooltipStyles}
            />
        </>
      }
      onClose={() => {
        onChange(false, highlights);
      }}
      className={styles.messageModal}
    />
  );
}
